import { isPaletteItemAvailable, } from "./capabilities.js";
function actionStmt(action) {
    return { type: "action", action };
}
function ifWithTest(test) {
    return {
        type: "if",
        test,
        then: [actionStmt({ type: "keep" })],
        elsif: [],
    };
}
export const PALETTE_ITEMS = [
    {
        id: "if",
        label: "If condition",
        kind: "control",
        createStatement: () => ifWithTest({
            type: "header",
            headers: ["Subject"],
            keys: [""],
            match: { matchType: "contains" },
        }),
    },
    {
        id: "header",
        label: "Header test",
        kind: "test",
        createStatement: () => ifWithTest({
            type: "header",
            headers: ["From"],
            keys: [""],
            match: { matchType: "contains" },
        }),
    },
    {
        id: "address",
        label: "Address test",
        kind: "test",
        createStatement: () => ifWithTest({
            type: "address",
            headers: ["From"],
            keys: [""],
            match: { matchType: "is", addressPart: "all" },
        }),
    },
    {
        id: "envelope",
        label: "Envelope test",
        kind: "test",
        requires: ["envelope"],
        createStatement: () => ifWithTest({
            type: "envelope",
            fields: ["from"],
            keys: [""],
            match: { matchType: "is" },
        }),
    },
    {
        id: "size",
        label: "Size test",
        kind: "test",
        createStatement: () => ifWithTest({ type: "size", over: 1000000 }),
    },
    {
        id: "exists",
        label: "Exists test",
        kind: "test",
        createStatement: () => ifWithTest({ type: "exists", headers: ["X-Spam-Flag"] }),
    },
    {
        id: "body",
        label: "Body test",
        kind: "test",
        requires: ["body"],
        createStatement: () => ifWithTest({
            type: "body",
            keys: [""],
            match: { matchType: "contains" },
            bodyTransform: "text",
        }),
    },
    {
        id: "date",
        label: "Date test",
        kind: "test",
        requires: ["date"],
        createStatement: () => ifWithTest({
            type: "date",
            header: "Date",
            datePart: "date",
            keys: [""],
            match: { matchType: "is" },
        }),
    },
    {
        id: "mailboxexists",
        label: "Mailbox exists",
        kind: "test",
        requires: ["mailbox"],
        createStatement: () => ifWithTest({ type: "mailboxexists", mailboxes: ["INBOX"] }),
    },
    {
        id: "duplicate",
        label: "Duplicate test",
        kind: "test",
        requires: ["duplicate"],
        createStatement: () => ifWithTest({ type: "duplicate" }),
    },
    {
        id: "keep",
        label: "Keep",
        kind: "action",
        createStatement: () => actionStmt({ type: "keep" }),
    },
    {
        id: "discard",
        label: "Discard",
        kind: "action",
        createStatement: () => actionStmt({ type: "discard" }),
    },
    {
        id: "stop",
        label: "Stop",
        kind: "action",
        createStatement: () => actionStmt({ type: "stop" }),
    },
    {
        id: "redirect",
        label: "Redirect",
        kind: "action",
        createStatement: () => actionStmt({ type: "redirect", address: "" }),
    },
    {
        id: "reject",
        label: "Reject",
        kind: "action",
        requires: ["reject"],
        createStatement: () => actionStmt({ type: "reject", reason: "Rejected" }),
    },
    {
        id: "fileinto",
        label: "File into",
        kind: "action",
        requires: ["fileinto"],
        createStatement: () => actionStmt({ type: "fileinto", mailbox: "INBOX" }),
    },
    {
        id: "vacation",
        label: "Vacation reply",
        kind: "action",
        requires: ["vacation"],
        createStatement: () => actionStmt({
            type: "vacation",
            days: 7,
            subject: "Out of office",
            message: "I am currently away from email.",
        }),
    },
    {
        id: "addflag",
        label: "Add flag",
        kind: "action",
        requires: ["imap4flags"],
        createStatement: () => actionStmt({ type: "addflag", flags: ["\\Seen"] }),
    },
    {
        id: "setflag",
        label: "Set flag",
        kind: "action",
        requires: ["imap4flags"],
        createStatement: () => actionStmt({ type: "setflag", flags: ["\\Flagged"] }),
    },
    {
        id: "removeflag",
        label: "Remove flag",
        kind: "action",
        requires: ["imap4flags"],
        createStatement: () => actionStmt({ type: "removeflag", flags: ["\\Seen"] }),
    },
    {
        id: "set",
        label: "Set variable",
        kind: "action",
        requires: ["variables"],
        createStatement: () => actionStmt({ type: "set", name: "name", value: "value" }),
    },
    {
        id: "include",
        label: "Include script",
        kind: "action",
        requires: ["include"],
        createStatement: () => actionStmt({ type: "include", location: "personal", script: "other" }),
    },
    {
        id: "notify",
        label: "Notify",
        kind: "action",
        requires: ["enotify"],
        createStatement: () => actionStmt({ type: "notify", method: "mailto:you@example.com", message: "New mail" }),
    },
];
export function availablePalette(capabilities) {
    return PALETTE_ITEMS.filter((item) => isPaletteItemAvailable(capabilities, item));
}
export function describeStatement(stmt) {
    if (stmt.type === "if")
        return `if ${describeTest(stmt.test)}`;
    if (stmt.type === "action")
        return describeAction(stmt.action);
    if (stmt.type === "comment")
        return `# ${stmt.text}`;
    if (stmt.type === "require")
        return `require ${stmt.extensions.join(", ")}`;
    return "opaque";
}
function describeTest(test) {
    switch (test.type) {
        case "header":
            return `header ${test.headers.join(",")} ${test.match.matchType ?? "is"} ${test.keys.join(",")}`;
        case "address":
            return `address ${test.headers.join(",")}`;
        case "envelope":
            return `envelope ${test.fields.join(",")}`;
        case "size":
            return test.over != null ? `size > ${test.over}` : `size < ${test.under}`;
        case "exists":
            return `exists ${test.headers.join(",")}`;
        case "body":
            return `body ${test.keys.join(",")}`;
        case "not":
            return `not (${describeTest(test.test)})`;
        case "allof":
            return `allof (${test.tests.length})`;
        case "anyof":
            return `anyof (${test.tests.length})`;
        case "true":
            return "true";
        case "false":
            return "false";
        default:
            return test.type;
    }
}
function describeAction(action) {
    switch (action.type) {
        case "fileinto":
            return `fileinto ${action.mailbox}`;
        case "redirect":
            return `redirect ${action.address}`;
        case "vacation":
            return "vacation";
        case "include":
            return `include ${action.script}`;
        case "opaque":
            return action.text.slice(0, 40);
        default:
            return action.type;
    }
}
export function appendPaletteItem(ast, item) {
    return {
        ...ast,
        statements: [...ast.statements.filter((s) => s.type !== "require"), item.createStatement()],
    };
}
